import React from "react";
import CustomTranslation from "../../Components/CustomTranslation";
import Loader from "../../Components/Loader";
import { Button, Table, Modal, Image, Spinner } from "react-bootstrap";
import G from "../../../Actions/GeneralAction";
import AssignmentAction from "../../../Actions/AssignmentAction";
import { generatePath } from "react-router-dom";
import UserAction from "../../../Actions/UserAction";
import TranslationAction from "../../../Actions/TranslationAction";
import CustomInput from "../../Components/CustomInput";

//define class
class AssignmentArchiveModal extends React.Component {

    //constructor
    constructor(props) {
        super(props);

        //init state
        this.state = {
            showModal: true,
            assignment: null
        };
    }

    //on load
    componentDidMount = () => {
        this.updateElements();
    }

    //update
    updateElements = async () => {
        //call
        let assignment = await AssignmentAction.get(this.props.data.id);

        //user
        let user = await UserAction.getCurrentUser();

        //title
        let title = await TranslationAction.translate('KEY.Sure about delete assignment?');

        //set in state
        this.setState({
            assignment: assignment,
            isLoaded: true,
            user: user,
            title: title,
            reason: '',
            forwardUser: { id: assignment.targetUser.id },
        });
    }

    //on close
    onClose = async () => {
        this.setState({
            showModal: false
        });
        this.props.onClose();
    }


    //render view
    render = () => {
        if (this.state.assignment) {
            return (
                <Modal show={this.state.showModal} onHide={() => this.onClose()} backdrop={'static'} keyboard={false}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.state.title}
                        </Modal.Title>
                    </Modal.Header>
                    {/* Modal body */}
                    <Modal.Body>
                        <CustomInput
                            label={<CustomTranslation value={'KEY.Reason for delete'} />}
                            iconName={'las la-comment'}
                            onChangeText={(value) => {
                                this.setState({reason: value});
                            }}
                        />
                        
                        {(this.state.assignment.sender.id === this.state.user.id || this.state.assignment.targetUser.id === this.state.user.id) &&
                            <Button
                                style={{ marginTop: 6 }}
                                block
                                disabled={this.state.reason.trim() === ''}
                                variant={'dark'}
                                onClick={async () => {
                                    const comment = `${this.state.assignment?.comment ?? ''}\n` +
                                                    `${this.state.user.lastName} ${this.state.user.firstName} : ${this.state.reason}`;
                                    await AssignmentAction.save({...this.state.assignment, ... {comment: comment, id: this.state.assignment.id, finished: this.state.assignment.finished, forwardUser: this.state.forwardUser,}});
                                    let result = await AssignmentAction.archive(this.state.assignment.id, this.state.assignment.archivedAt ? false : true);

                                    if (result.status === 'success') {
                                        this.setState({ showModal: false }, () => {
                                            if (this.props.onSuccess) this.props.onSuccess();
                                            else this.onClose(); 
                                        });
                                    }
                                }}
                            >
                                <CustomTranslation value={'KEY.Save'} />
                            </Button>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button block variant={'dark'} onClick={() => this.onClose()}>
                            <CustomTranslation value={'KEY.Cancel'} />
                        </Button>
                    </Modal.Footer>
                </Modal>
            );
        } else {
            return (
                <Modal show={this.state.showModal} backdrop={'static'} keyboard={false}>
                    <Modal.Body>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                            <Spinner animation={'border'} variant={'primary'} />
                        </div>
                    </Modal.Body>
                </Modal>
            );
        }
    }
}

//export
export default AssignmentArchiveModal;